import React, { useState } from 'react'
import './SostenibilidadConfigContainer.css'
import { getPermissions } from '@auteco/utils/Common'
import SedesSostenibilidadContainer from '../../components/SostenibilidadComponents/SedesSostenibilidadContainer'
import UsuariosSostenibilidadContainer from '../../components/SostenibilidadComponents/UsuariosSostenibilidadContainer'
import PreciosSostenibilidadContainer from '../../components/SostenibilidadComponents/PreciosSostenibilidadContainer'
// Componentes individuales para cada pestaña

const SostenibilidadConfigContainer = () => {
  const [activeTab, setActiveTab] = useState('Empresas')

  const tabs = ['Ensambladoras', 'Sedes', 'Tipos']

  const permissions = getPermissions()

  if (permissions[73] && permissions[73] != 5) {
    return <p>Permisos insuficientes</p>
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'Ensambladoras':
        return <UsuariosSostenibilidadContainer />
      case 'Sedes':
        return <SedesSostenibilidadContainer />
      case 'Tipos':
        return <PreciosSostenibilidadContainer />

      default:
        return <UsuariosSostenibilidadContainer />
    }
  }

  return (
    <div>
      <div>
        {tabs.map((tab) => (
          <button
            className="tab_button_config"
            key={tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="config_container">{renderContent()}</div>
    </div>
  )
}

export default SostenibilidadConfigContainer
